import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseButton, IconButton, Typography } from 'seagull';
import { BrushIcon } from 'seagull/icons';
import { Intent } from '~/infra/access-control';
import { PreviewState } from '../ClientOnboarding.utils';
import styles from './PreviewBanner.module.scss';
export const PreviewBanner = (param)=>{
    let { testId = 'cob-preview-banner', previewState, localPreviewState, onToggleBrandSetup, onDismiss, showBrandSetupButton = false } = param;
    const hasButtons = onDismiss || showBrandSetupButton && onToggleBrandSetup;
    if (hasButtons) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.headerContainer,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    weight: "normal",
                    skin: "invertedStandard",
                    className: styles.previewBannerV2,
                    testId: testId,
                    children: "You are in preview mode. No activity will be saved."
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerButtonsContainer,
                    children: [
                        showBrandSetupButton && onToggleBrandSetup && previewState !== PreviewState.SetupBrand && /*#__PURE__*/ _jsx(IconButton, {
                            intent: Intent.BrandSetup,
                            preferIntentTooltip: true,
                            skin: "whiteAndPurple",
                            className: "".concat(styles.brushBtn, " ").concat(localPreviewState === PreviewState.SetupBrand ? styles.brushBtnActive : ''),
                            testId: "client-preview-modal-toggle-brand-setup-btn",
                            onClick: onToggleBrandSetup,
                            tooltip: {
                                title: 'Customize brand'
                            },
                            children: /*#__PURE__*/ _jsx(BrushIcon, {
                                size: 24
                            })
                        }),
                        /*#__PURE__*/ _jsx(CloseButton, {
                            testId: "client-preview-modal-close-btn",
                            skin: "whiteAndPurple",
                            className: styles.closeBtn,
                            onClick: onDismiss
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Typography, {
        weight: "normal",
        skin: "invertedStandard",
        className: styles.previewBanner,
        testId: testId,
        children: "You are in preview mode. No activity will be saved."
    });
};
